function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 *
 */
import { useCssInJs } from "../../hooks";
import '@formily/antd-v5';
import { ConfigProvider, Divider } from 'antd';
import cls from 'classnames';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { TaskListProvider, useTaskList } from "./TaskListStore";
import SearchModal from "./components/SearchModal";
import TaskDetail, { useTaskDetailDrawer } from "./components/TaskDetail";
import FilterHeader from "./components/filterHeader";
import LeftFilterHeader from "./components/leftFilterHeader";
import LeftTaskList from "./components/leftTaskList";
import { genTaskStyles } from "./styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function TaskList() {
  var _state$flowParams, _state$flowParams2, _state$flowParams3;
  var prefix = 'tasklist';
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: genTaskStyles
    }),
    wrapSSR = _useCssInJs.wrapSSR,
    hashId = _useCssInJs.hashId;
  var _useTaskList = useTaskList(),
    _useTaskList2 = _slicedToArray(_useTaskList, 2),
    state = _useTaskList2[1];
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var openTaskDetail = useTaskDetailDrawer();
  var flowOrderId = searchParams.get('flowOrderId') || undefined;
  var taskOrderId = searchParams.get('taskOrderId') || undefined;
  useEffect(function () {
    if (flowOrderId || taskOrderId) {
      // http://localhost:3000/Task?flowOrderId=2114971439521797&taskOrderId=2124971439521806
      openTaskDetail({
        taskOrderId: taskOrderId,
        flowOrderId: flowOrderId
      }).catch(function () {});
    }
  }, [flowOrderId, taskOrderId]);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  useEffect(function () {
    window.addEventListener('keydown', handleKeyDown);
    return function () {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  var handleKeyDown = function handleKeyDown(event) {
    if ((event.ctrlKey || event.metaKey) && event.key === 'k') {
      setIsOpen(true);
    }
    if (event.key === 'Escape') {
      setIsOpen(false);
    }
  };
  return wrapSSR( /*#__PURE__*/_jsx(ConfigProvider, {
    theme: {
      components: {
        Segmented: {
          trackBg: '#FFFFFF',
          itemSelectedBg: '#FFFFFF'
        }
      }
    },
    children: /*#__PURE__*/_jsxs("div", {
      className: cls(prefix, hashId),
      children: [isOpen ? /*#__PURE__*/_jsx(SearchModal, {
        open: isOpen,
        onCancel: function onCancel() {
          return setIsOpen(false);
        },
        onModalOpen: setIsOpen,
        handleClick: function handleClick(taskOrderId, flowOrderId) {
          openTaskDetail({
            taskOrderId: taskOrderId,
            flowOrderId: flowOrderId
          }).catch(function () {});
          setIsOpen(false);
        }
      }) : null, /*#__PURE__*/_jsxs("div", {
        className: "task-container",
        children: [/*#__PURE__*/_jsx(FilterHeader, {
          onModalOpen: setIsOpen
        }), /*#__PURE__*/_jsx(Divider, {
          className: "top-divider"
        }), /*#__PURE__*/_jsxs("div", {
          className: "bottom",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "left",
            children: [/*#__PURE__*/_jsx(LeftFilterHeader, {}), /*#__PURE__*/_jsx(LeftTaskList, {})]
          }), /*#__PURE__*/_jsx("div", {
            className: "right",
            children: state.flowParams ? /*#__PURE__*/_jsx(TaskDetail, {
              flowOrderId: (_state$flowParams = state.flowParams) === null || _state$flowParams === void 0 ? void 0 : _state$flowParams.flowOrderId,
              taskOrderId: (_state$flowParams2 = state.flowParams) === null || _state$flowParams2 === void 0 ? void 0 : _state$flowParams2.taskOrderId,
              detailLink: (_state$flowParams3 = state.flowParams) === null || _state$flowParams3 === void 0 ? void 0 : _state$flowParams3.detailLink
            }) : null
          })]
        })]
      })]
    })
  }));
}
export default function WrappedTaskList() {
  return /*#__PURE__*/_jsx(TaskListProvider, {
    children: /*#__PURE__*/_jsx(TaskList, {})
  });
}